// extracted by mini-css-extract-plugin
export default {"totals_row":"reportTable_totals_row__0lFTh"};